import React, { useState, useEffect } from 'react'
import {
    Button, Dialog, Grid, Icon, Typography, Select, Switch, Radio,
    FormGroup, FormControl, FormHelperText, RadioGroup, FormControlLabel
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import useStyles from "./styles";
import { Label, DraggableComponent } from '../../../../../components/UiElements/UiElements';
import DialogLoader from './../../../../../components/Loader/DialogLoader';
import { withSnackbar } from "./../../../../../components/Message/Alert";
import { PostDataAPI } from "../../../../../Services/APIService";
import SearchGrid from '../../../../../components/table/SearchGrid';
import { formatDateTime, getLocalDateFromUTC } from '../../../../../components/Common/Extensions';
import { ActionDialog } from "../../../../../components/ActionDialog/ActionDialog";

function LosView({ dialogOpenClose, handleClose, handleSuccessClose, selectedItem, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }
    const [gridData, setGridData] = useState([]);
    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }
    const loadLOSUploadedDocuments = () => {
        setIsLoading(true);
        var method = "letterofsupport/loadLOSDocumentsGrid";

        var params = { letterOfSupportId: selectedItem.letterOfSupportId }
        PostDataAPI(method, params, true).then((result) => {
            if (result.success && result.data) {
                setGridData(result.data.map(item => {
                    item.createDate = formatDateTime(getLocalDateFromUTC(item.createDate));
                    return {...item}
                }));
                handleDataGridUpdate()
            }
            else {
                showMessage("Error", result.message, "error", 3000);

            }
            setIsLoading(false);

        })
    }

    const openDocument = (key,item) => {
        window.open('.'+item.docPath, '_blank');
    }

    const deleteLOSAgencyDoc = (item) => {
        showActionDialog("Are you sure you want to delete this record?", "confirm", function () {
            var params = { docId: item.docId }
            setIsLoading(true);
            PostDataAPI("letterofsupport/deleteAgencyDocument", params, true).then((result) => {
                if (result.success) {
                    showMessage("Success", "Record deleted successfully", "success", 3000);
                    loadLOSUploadedDocuments();
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);
            })
        });
    }
    useEffect(() => {
        loadLOSUploadedDocuments();
    }, []);


    return (
        <>

            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="md"
                PaperComponent={DraggableComponent}
                {...props} >
                <div className={classes.activeDialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>Letter Of Support Received</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>
                        {isLoading ? <DialogLoader></DialogLoader> : ''}


                        <div className={classes.contentSecond}>

                            <SearchGrid
                                columns="LOSAgencyDocumentList"
                                list={gridData}
                                noRecordMsg="No record exists"
                                Icon={true}
                                isUpdate={isDataGridUpdate}
                                onDeleteClick={deleteLOSAgencyDoc}
                                onActionClick={ openDocument}
                            />

                        </div>

                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            </div>
                        </div>

                    </div>
                </div>

            </Dialog >
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />
        </>
    )
}

export default withSnackbar(LosView); 